module.exports = __webpack_public_path__ + "img/money-bills.6a654c8f.svg";